/**
 * Constants and config for Transaction Detail (DR Sync Details) page.
 */

export const TAB_INDEX = {
  SYNC_SUMMARY: 0,
  TERRAFORM_ERRORS: 1,
  EXPORTED_FLOW_DETAILS: 2,
  PUBLISHED_FLOW_DETAILS: 3,
  UNSUPPORTED_FLOWS: 4,
} as const;

export const SYNC_SUMMARY_STEPS = [
  { key: 'stepOne', step: 'sourceExport', minPct: undefined as number | undefined },
  { key: 'stepTwo', step: 'validateTfvars', minPct: undefined },
  { key: 'stepThree', step: 'exportFlows', minPct: undefined },
  { key: 'stepFour', step: 'destExport', minPct: undefined },
  { key: 'stepFive', step: 'setupImport', minPct: undefined },
  { key: 'stepSix', step: 'importOrg', minPct: 40 },
  { key: 'stepSeven', step: 'publishSkeletonFlows', minPct: undefined },
  { key: 'stepEight', step: 'firstPublishFlowsFromSource', minPct: undefined },
  { key: 'stepNine', step: 'importOrg', minPct: 100 },
  { key: 'stepTen', step: 'emailNotification', minPct: undefined },
] as const;

export const STEP_LABELS: Record<string, string> = {
  sourceExport: 'Export Source',
  validateTfvars: 'Terraform Variable Parameter Entry',
  exportFlows: 'Export Flows',
  destExport: 'Export Destination',
  setupImport: 'Import Setup',
  importOrg: 'Import Pass #1',
  publishSkeletonFlows: 'Publish Skeleton Flows',
  firstPublishFlowsFromSource: 'Publish Final Flow Configuration',
  emailNotification: 'Email Notification',
};

